import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { apiQueryOrganizationSupplierDetailInfo } from '../api/organizationSupplier';
export var createSupplierSubsidiaryStore = create()(immer(function (set, get) {
  return {
    state: {
      subsidirayList: [],
      subsidiaryLoading: false
    },
    actions: {
      initSubsidiaryInfo: function () {
        var _initSubsidiaryInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
          var _yield$apiQueryOrgani, _yield$apiQueryOrgani2, res;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  set(function (store) {
                    store.state.subsidiaryLoading = true;
                  });
                  _context.next = 3;
                  return apiQueryOrganizationSupplierDetailInfo(_objectSpread({}, data));

                case 3:
                  _yield$apiQueryOrgani = _context.sent;
                  _yield$apiQueryOrgani2 = _slicedToArray(_yield$apiQueryOrgani, 1);
                  res = _yield$apiQueryOrgani2[0];
                  set(function (store) {
                    store.state.subsidirayList = res === null || res === void 0 ? void 0 : res.supplier_subsidiaries;
                    store.state.subsidiaryLoading = false;
                  });

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function initSubsidiaryInfo(_x) {
          return _initSubsidiaryInfo.apply(this, arguments);
        }

        return initSubsidiaryInfo;
      }()
    }
  };
}));